




import Vue                      from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'

const map: { [key: string]: Promise<string> } = {}

async function loadIcon(src: string): Promise<string> {
    if (!map[src]) {
        map[src] = fetch(src).then((r) => r.text())
    }
    return await map[src]
}

@Component
export default class SVGIcon extends Vue {
    @Prop(String)
    private src!: string
    private icon: string = ''

    @Watch('src')
    protected async mounted() {
        this.icon = await loadIcon(this.src)
    }
}
